export default __webpack_public_path__ + "images/extensionPromoLight_490766.png";